import React from 'react';
import CountUp from './CountUp';
import { formatWinPct } from '../../utils/formatStats';

// Stat tiles shared by the profile tab and the player card modal, so both show
// the same numbers in the same style (#35 follow-up)
export default function PlayerStatTiles({ playerStats = {}, eventWins = 0, longestStreak = 0, layout = 'card' }) {
  const headlineStats = [
    { label: 'Match W / L', value: `${playerStats.w ?? 0} / ${playerStats.l ?? 0}` },
    { label: 'Win %', value: formatWinPct(playerStats) },
  ];
  const secondaryStats = [
    { label: 'Games W / L', value: `${playerStats.gw ?? 0} / ${playerStats.gl ?? 0}` },
    { label: 'MVPs', value: playerStats.mvp ?? 0 },
    { label: 'Event wins', value: eventWins },
    { label: 'Longest streak', value: longestStreak },
  ];

  // Profile tab: one 2-column grid of equal tiles with primary labels (Figma 791:19180)
  if (layout === 'grid') {
    const gridStats = [
      headlineStats[0],
      headlineStats[1],
      secondaryStats[0],
      { label: 'Longest streak', value: longestStreak },
      { label: 'MVPs', value: playerStats.mvp ?? 0 },
      { label: 'Event wins', value: eventWins },
    ];
    return (
      <div className="profile-stats">
        {gridStats.map(({ label, value }, i) => {
          const wave = Math.floor(i / 2) + (i % 2); // diagonal ripple down the grid
          return (
            <div key={label} className="profile-stat pc-anim-tile" style={{ '--pc-d': wave }}>
              <span className="profile-stat__label">{label}</span>
              <span className="profile-stat__value">
                <CountUp value={value} delay={wave * 90 + 600} />
              </span>
            </div>
          );
        })}
      </div>
    );
  }

  return (
    <>
      {/* HEADLINE STATS: MATCH RESULTS (SURFACE-CONTAINER-LIGHT) */}
      <div className="w-full grid grid-cols-2 gap-3 mb-3">
        {headlineStats.map(({ label, value }, i) => (
          <div
            key={label}
            className="pc-anim-tile rounded-2xl p-3.5 flex flex-col items-center justify-center text-center shadow-md border border-white/5"
            style={{ backgroundColor: 'var(--surface-container-light)', '--pc-d': i }}
          >
            <span className="text-xs font-bold text-slate-300 uppercase tracking-wider mb-1">{label}</span>
            <span className="font-nunito-black-italic text-3xl sm:text-4xl text-white drop-shadow-md">
              <CountUp value={value} delay={i * 90 + 600} />
            </span>
          </div>
        ))}
      </div>

      {/* SECONDARY STATS: GAMES, MVPS AND HONOURS */}
      <div className="w-full grid grid-cols-2 sm:grid-cols-4 gap-3 mb-6">
        {secondaryStats.map(({ label, value }, i) => {
          const wave = Math.floor(i / 2) + (i % 2) + 1; // diagonal ripple continuing below the headline row
          return (
            <div
              key={label}
              className="pc-anim-tile rounded-2xl p-3 flex flex-col items-center justify-center text-center shadow-md border border-white/5"
              style={{ backgroundColor: 'var(--surface-container-light)', '--pc-d': wave }}
            >
              <span className="text-[10px] font-bold text-slate-400 uppercase tracking-wider mb-1">{label}</span>
              <span className="font-nunito-black-italic text-xl sm:text-2xl text-white drop-shadow-md">
                <CountUp value={value} delay={wave * 90 + 600} />
              </span>
            </div>
          );
        })}
      </div>
    </>
  );
}
